import React from "react";
import "../../../../css/Common/Components/Cards/CardProduct2.css";
import "../../../../css/App.css";
import { useState } from "react";

/**
 * CardProduct2 is a React functional component that renders a styled card UI element.
 * The card displays a title and optional content, and can be styled differently if it represents an adviser.
 * It also tracks its clicked state and triggers a callback when clicked.
 *
 * @param {Object} props - The component props.
 * @param {string} props.title - The title to display on the card.
 * @param {string} [props.content=""] - Optional content to display inside the card.
 * @param {boolean} [props.isAdviser=false] - If true, applies adviser-specific styling to the card.
 * @param {Function} props.onClick - Callback function to execute when the card is clicked.
 *
 * @returns {JSX.Element} The rendered CardProduct2 component.
 */
const CardProduct2 = ({ title, content = "", isAdviser = false, onClick }) => {
  const [clicked, setClicked] = useState(false);

  return (
    <>
      <div
        className={`Card-Product2 ${isAdviser ? "Adviser" : ""}  ${
          clicked ? "clicked" : ""
        }`}
        onClick={() => {
          setClicked(!clicked);
          onClick();
        }}
      >
        {content ? <h4>{title}</h4> : <h2>{title} </h2>}
        <div className="Content">{content}</div>
      </div>
    </>
  );
};

export default CardProduct2;
